/** Maximum lines per component file */
export const MAX_COMPONENT_LINES = 300

/** Maximum lines per hook file */
export const MAX_HOOK_LINES = 200

/** App name */
export const APP_NAME = "ToToDo"

/** App version — injected from version.json at build time via Vite `define` */
export const APP_VERSION: string = __APP_VERSION__

/** Build number — git commit count, injected at build time */
export const BUILD_NUMBER: string = __BUILD_NUMBER__

/** Build timestamp — ISO string, injected at build time */
export const BUILD_TIMESTAMP: string = __BUILD_TIMESTAMP__
